import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getCalculatedMaximumQuantity } from '@grandvisionhq/utils';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { ProductQuantitySelector } from '../../../components/ProductQuantitySelector/ProductQuantitySelector.js';
import { useAccessoriesEcommContext } from '../../context/AccessoriesEcommContext.js';

const AccessoriesQuantitySelector = ()=>{
    const { activeVariant  } = useProductData();
    const { channelAvailability , stock  } = activeVariant;
    const { setQuantity , quantity , maxOrderableQuantity  } = useAccessoriesEcommContext();
    const { isAccessoriesPdpQuantitySelectorDisabled  } = useFeatureToggles();
    const maxSelectableQuantity = getCalculatedMaximumQuantity(maxOrderableQuantity, stock.stockCount, stock.isAllowBackOrder);
    const onDecreaseQuantity = ()=>{
        setQuantity(quantity - 1);
    };
    const onIncreaseQuantity = ()=>{
        setQuantity(quantity + 1);
    };
    if (channelAvailability !== 'ONLINE' || isAccessoriesPdpQuantitySelectorDisabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductQuantitySelector, {
        className: "accessories-quantity-selector",
        quantity: quantity,
        maximumQuantity: maxSelectableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity
    });
};

export { AccessoriesQuantitySelector };
//# sourceMappingURL=AccessoriesQuantitySelector.js.map
